import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { isSome, formatCurrency, translate, formatDate, isCurrentDateGreater } from 'core/utils';
import { BaasicCheckbox, BaasicAsyncCreatableSelect } from 'core/components';
import {
	fulfillmentOrderStatus,
	onAssignStatuses,
	onSplitFulfillmentOrderStatuses,
	onHoldStatuses,
	onCancelStatuses,
	onChangeShippingStatuses,
	onStatusChangeStatuses,
	onPrintLabelStatuses,
	onPrintPackingSlipStatuses,
	onPullLabelStatuses,
	onNeverShippedStatuses,
	onMarkAsShippedStatuses,
	onReoptimizeStatuses,
	orderStatus,
	onHoldReason,
	conversionRates,
	voidLabelStatuses,
	orderLineStatusesForSplit,
	channelType,
	orderLineStatuses,
} from 'common/constants';
import { CostBreakdownTooltip } from 'common/tooltips';
import moment from 'moment';
import _, { isArray } from 'lodash';

@observer
class CustomActions extends React.Component {
	render() {
		const {
			t,
			viewStore,
			viewStore: {
				isPickingMode,
				isBulkPrintMode,
				isSeller,
				isSuperAdminOrganization,
				hasPiiAccess,
				isChannelAmazon,
				hasAllFOsPastExitScan,
				isSuperAdmin,
				tableData: {
					actions: {
						onEdit,
						onEditOrder,
						onDelete,
						onReturnAddressDelete,
						onSync,
						onDetails,
						onLinkOrderLine,
						onRefundOrderLine,
						onCancelOrder,
						onCreateReturnLabel,
						onPasswordChange,
						onAssign,
						onSplit,
						onChoose,
						onCheck,
						onCollect,
						onLabelScan,
						onRemoveFromPallet,
						onChangeStatus,
						onHold,
						onCancel,
						onChangeShipping,
						onSplitFulfillmentOrder,
						onStatusChange,
						onPrintReturnLabel,
						onReprintLabels,
						onPullLabel,
						onReplace,
						onNeverShipped,
						onMarkAsShipped,
						onReoptimize,
						onChangeOrganizationActive,
						onProductActivity,
						onLinkProduct,
						onResync,
						onPicklistPrint,
						onExportToCSV,
						onPrintLabel,
						onPrintPackingSlip,
						onVoidLabel,
						onPrintBulkHistory,
						onEditChannelWarehouseCodes,
						onEditChannelCustomLabel,
						onEditSeller3PLCredentials,
						onEditSellerWarehouses,
						onUserEdit,
						onReturnAddressEdit,
					},
				},
			},
			rowType,
			dataItem,
			dataIndex,
		} = this.props;
		if (rowType === 'groupHeader') {
			return null;
		}
		const returnedActions = checkPermissions(viewStore);

		const showSplitAction = _.has(dataItem, 'orderLines')
			? dataItem.orderLines.some(ol => {
					return orderLineStatusesForSplit.includes(ol.orderLineStatus.abrv);
			  })
			: null;

		const hasUnlinkedOrderLines =
			(_.has(dataItem, 'product')
				? dataItem.product == null
				: dataItem.orderLines && dataItem.orderLines.length != 0
				? _.find(dataItem.orderLines, item => {
						return item.productId == null;
				  }) != undefined
				: false) ||
			(isSome(dataItem.unlinkedProductCount) && dataItem.unlinkedProductCount > 0);

		const nonPalletizedStatus = _.has(dataItem, 'fulfillmentOrder.fulfillmentOrderStatus')
			? dataItem.fulfillmentOrder.fulfillmentOrderStatus.abrv != fulfillmentOrderStatus.palletized
			: _.has(dataItem, 'fulfillmentOrderStatus')
			? dataItem.fulfillmentOrderStatusAbrv != fulfillmentOrderStatus.palletized
			: null;

		const hasLabel =
			_.find(dataItem.shipmentInfos, item => {
				return isSome(item.label) && item.shipmentInfoStatus.abrv == 'active';
			}) ||
			(isSome(dataItem.activeShipmentCount) && dataItem.activeShipmentCount > 0);

		const editFulfillmentOrderSplit =
			!hasLabel &&
			(_.has(dataItem, 'isSplit') || _.has(dataItem, 'isCreatedBySplit')
				? dataItem.isSplit || (dataItem.isCreatedBySplit && dataItem.originalFulfillmentOrderIdInt)
				: false);

		const notManualOrder = _.has(dataItem, 'channelType.abrv')
			? dataItem.channelType.abrv != 'manual%20orders'
			: _.has(dataItem, 'orderChannelTypeAbrv')
			? dataItem.orderChannelTypeAbrv != 'manual%20orders'
			: null;

		const notVendorOrder = _.has(dataItem, 'channelType.abrv')
			? dataItem.channelType.abrv != 'amazon%20vendor'
			: _.has(dataItem, 'orderChannelTypeAbrv')
			? dataItem.orderChannelTypeAbrv != 'amazon%20vendor'
			: null;

		const nonCancelHoldReason = _.has(dataItem, 'onHoldReasonAbrv')
			? dataItem.onHoldReasonAbrv != onHoldReason.toBeCancelled
			: _.has(dataItem, 'onHoldReason.abrv')
			? dataItem.onHoldReason.abrv != onHoldReason.toBeCancelled
			: true;

		const assignmentStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onAssignStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onAssignStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const splittingStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onSplitFulfillmentOrderStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onSplitFulfillmentOrderStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const holdingStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onHoldStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onHoldStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const voidLabelStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(voidLabelStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(voidLabelStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onCancelStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onCancelStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onCancelStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onChangeShippingStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onChangeShippingStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onChangeShippingStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onPrintLabelStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onPrintLabelStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onPrintLabelStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onPrintPackingSlipStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onPrintPackingSlipStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onPrintPackingSlipStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onStatusChangeStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onStatusChangeStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onStatusChangeStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onPullLabelStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onPullLabelStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onPullLabelStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onNeverShippedStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onNeverShippedStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onNeverShippedStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onMarkAsShippedStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onMarkAsShippedStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onMarkAsShippedStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const onReoptimizeStatus = _.has(dataItem, 'fulfillmentOrderStatusAbrv')
			? _.findIndex(onReoptimizeStatuses, item => item == dataItem.fulfillmentOrderStatusAbrv) != -1
			: _.has(dataItem, 'fulfillmentOrderStatus.abrv')
			? _.findIndex(onReoptimizeStatuses, item => item == dataItem.fulfillmentOrderStatus.abrv) != -1
			: null;

		const isBuyerRequestedCancel = _.has(dataItem, 'orderLines')
			? dataItem.orderLines && dataItem.orderLines.length != 0
				? _.some(dataItem.orderLines, item => {
						return item.isBuyerRequestedCancel == true;
				  })
				: false
			: null;

		const hasNoShipmentInfos = _.has(dataItem, 'fulfillmentOrders')
			? dataItem.fulfillmentOrders && dataItem.fulfillmentOrders.length != 0
				? _.every(dataItem.fulfillmentOrders, item => {
						return item.shipmentInfos == null || item.shipmentInfos.length == 0;
				  })
				: true
			: null;

		const isBoxRequired =
			_.has(dataItem, 'orderedItemCount') && _.has(dataItem, 'productQuantity')
				? dataItem.orderedItemCount > 1 || dataItem.productQuantity > 1
				: null;
		return (
			<td className={this.props.className || 'k-custom-actions k-custom-frozen'}>
				<div className="k-actions-list">
					{/* Edit Seller Warehouses */}
					{returnedActions.onEditSellerWarehouses && (
						<i
							title={t('SELLERWAREHOUSE.TITLE')}
							data-tip={t('SELLERWAREHOUSE.EDIT')}
							className="icon icon--grid-action icon--warehouse-change k-custom-clickable"
							onClick={() => onEditSellerWarehouses(dataItem)}
							data-cy={`${onEditSellerWarehouses.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Edit Seller 3PL Credentials */}
					{returnedActions.onEditSeller3PLCredentials && (
						<i
							title={t('SELLER3PLCREDENTIALS.TITLE')}
							data-tip={t('SELLER3PLCREDENTIALS.TITLE')}
							className="icon icon--grid-action icon--list-edit k-custom-clickable"
							onClick={() => onEditSeller3PLCredentials(dataItem)}
							data-cy={`${onEditSeller3PLCredentials.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onLinkProduct && (
						<i
							title={t('LINKPRODUCT')}
							className="fa fa-link k-custom-clickable"
							onClick={() => onLinkProduct(dataItem)}
							data-cy={`${onLinkProduct.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onProductActivity && (
						<i
							title={t('PRODUCTACTIVITY')}
							className="fa fa-history k-custom-clickable"
							onClick={() => onProductActivity(dataItem)}
							data-cy={`${onProductActivity.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Channel Sync */}
					{returnedActions.onSync && notManualOrder && (
						<i
							title={t('SYNC')}
							className="fa fa-sync k-custom-clickable"
							onClick={() => onSync(dataItem)}
							data-cy={`${onSync.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Edit Warehouse Codes */}
					{returnedActions.onEditChannelWarehouseCodes && notManualOrder && (
						<i
							title={t('WAREHOUSECODES.TITLE')}
							className="icon icon--grid-action icon--warehouse-code k-custom-clickable"
							onClick={() => onEditChannelWarehouseCodes(dataItem)}
							data-cy={`${onEditChannelWarehouseCodes.name}-${dataIndex}-action`}
						></i>
					)}
					{/* onEditChannelCustomLabel */}
					{returnedActions.onEditChannelCustomLabel && (
						<i
							title={t('CUSTOMLABEL.TITLE')}
							className="icon icon--grid-action icon--custom-label k-custom-clickable"
							onClick={() => onEditChannelCustomLabel(dataItem)}
							data-cy={`${onEditChannelCustomLabel.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onDetails && (
						<i
							title={t('ORDERVIEW.DETAILS')}
							className="fa fa-info-circle k-custom-clickable"
							onClick={() => onDetails(dataItem)}
							data-cy={`${onDetails.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onChoose && (
						<i
							title={t('CHOOSE')}
							className="fa fa-check-square k-custom-clickable"
							onClick={() => onChoose(dataItem)}
							data-cy={`${onChoose.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onCheck && (isPickingMode || isBulkPrintMode) && (
						<div className="display--ib">
							<BaasicCheckbox
								className="input--check"
								id={dataItem.id}
								onChange={() => onCheck(dataItem.id)}
								checked={dataItem.isAssigned}
							/>
						</div>
					)}
					{returnedActions.onEditOrder &&
						notVendorOrder &&
						hasPiiAccess &&
						!hasLabel &&
						!isPickingMode &&
						!isBulkPrintMode &&
						(isSeller || isSuperAdminOrganization) && (
							<i
								title={t('EDIT')}
								className="fa fa-edit k-custom-clickable"
								onClick={() => onEditOrder(dataItem)}
								data-cy={`${onEditOrder.name}-${dataIndex}-action`}
							></i>
						)}
					{/* Picking batch reprint labels. */}
					{returnedActions.onReprintLabels && dataItem.isPrintable && hasPiiAccess && (
						<i
							title={t('PRINTPICKLISTLABELS')}
							className="fa fa-print k-custom-clickable"
							onClick={() => onReprintLabels(dataItem)}
							data-cy={`${onReprintLabels.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onEdit &&
						(dataItem.channel != null && dataItem.channel.channelType != null
							? dataItem.channel.channelType.name === channelType.manualOrders && hasPiiAccess && !hasUnlinkedOrderLines
							: true) && (
							<i
								title={t('EDIT')}
								className="fa fa-edit k-custom-clickable"
								onClick={() => onEdit(dataItem)}
								data-cy={`${onEdit.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onUserEdit &&
						(isSuperAdmin || viewStore.rootStore.authStore.user.id == dataItem.coreUserId) && (
							<i
								title={t('EDIT')}
								className="fa fa-edit k-custom-clickable"
								onClick={() => onUserEdit(dataItem)}
								data-cy={`${onUserEdit.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onReturnAddressEdit && !dataItem.isWarehouse && (
						<i
							title={t('EDIT')}
							className="fa fa-edit k-custom-clickable"
							onClick={() => onReturnAddressEdit(dataItem)}
							data-cy={`${onReturnAddressEdit.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onDelete &&
						viewStore.rootStore.authStore.user.id != dataItem.coreUserId &&
						(viewStore.store_path != 'userListViewStore' || viewStore.isSuperAdmin) && (
							<i
								title={t('DELETE')}
								className="fa fa-trash k-custom-clickable"
								onClick={() => onDelete(dataItem)}
								data-cy={`${onDelete.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onReturnAddressDelete && !dataItem.isWarehouse && (
						<i
							title={t('DELETE')}
							className="fa fa-trash k-custom-clickable"
							onClick={() => onReturnAddressDelete(dataItem)}
							data-cy={`${onReturnAddressDelete.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onPasswordChange && viewStore.rootStore.authStore.user.id == dataItem.coreUserId && (
						<i
							title={t('CHANGEPASSWORD')}
							className="fa fa-key k-custom-clickable"
							onClick={() => onPasswordChange(dataItem)}
							data-cy={`${onPasswordChange.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onLinkOrderLine && hasUnlinkedOrderLines && (
						<i
							title={t('LINKORDERLINE')}
							className="fa fa-link k-custom-clickable"
							onClick={() => onLinkOrderLine(dataItem)}
							data-cy={`${onLinkOrderLine.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onRefundOrderLine &&
						hasPiiAccess &&
						hasAllFOsPastExitScan &&
						isChannelAmazon &&
						dataItem.orderLineStatus.abrv == orderLineStatuses.shipped && (
							<i
								title={t('REFUNDORDERLINE')}
								className="fa fa-hand-holding-usd k-custom-clickable"
								onClick={() => onRefundOrderLine(dataItem)}
								data-cy={`${onRefundOrderLine.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onCancelOrder &&
						hasPiiAccess &&
						((dataItem.channel.channelType.name == channelType.amazon && isBuyerRequestedCancel) ||
							(dataItem.channel.channelType.name == channelType.mirakl && dataItem.CanCancel)) &&
						hasNoShipmentInfos &&
						dataItem.orderStatus.abrv != orderStatus.canceled &&
						dataItem.orderStatus.abrv != orderStatus.shipped && (
							<i
								title={t('CANCELORDER')}
								className="fa fa-window-close k-custom-clickable"
								onClick={() => onCancelOrder(dataItem)}
								data-cy={`${onCancelOrder.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onAssign && assignmentStatus && !isPickingMode && !isBulkPrintMode && (
						<i
							title={t('ASSIGN')}
							className="fa fa-tag k-custom-clickable"
							onClick={() => onAssign(dataItem)}
							data-cy={`${onAssign.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onPrintBulkHistory && (
						<i
							title={t('PRINTBULKHISTORY')}
							className="fa fa-print k-custom-clickable"
							onClick={() => onPrintBulkHistory(dataItem)}
							data-cy={`${onPrintBulkHistory.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Split marketplace order */}
					{returnedActions.onSplit &&
						dataItem.fulfillmentOrders &&
						dataItem.fulfillmentOrders.length == 0 &&
						(dataItem.orderStatus.abrv == orderStatus.partiallyShipped ||
							dataItem.orderStatus.abrv == orderStatus.unshipped) &&
						dataItem.shippingCoreCountryId != null &&
						dataItem.shippingCoreCountryStateId != null &&
						showSplitAction &&
						isSuperAdminOrganization &&
						!hasUnlinkedOrderLines && (
							<i
								title={t('SPLITMARKETPLACEORDER')}
								className="fa fa-columns k-custom-clickable"
								onClick={() => onSplit(dataItem)}
								data-cy={`${onSplit.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onCollect && (
						<i
							title={t('FULFILLMENTORDER.SCANFULFILLMENTORDERITEM')}
							className="fa fa-chevron-circle-up k-custom-clickable"
							onClick={() => onCollect(dataItem)}
							data-cy={`${onCollect.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onLabelScan && (
						<i
							title={t('SHIPMENTINFO.COLLECT')}
							className="fa fa-chevron-circle-up k-custom-clickable"
							onClick={() => onLabelScan(dataItem)}
							data-cy={`${onLabelScan.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onRemoveFromPallet && (
						<i
							title={t('EXITSCANDETAILVIEW.TABLE.ACTION.REMOVEFROMPALLET')}
							className="fa fa-pallet k-custom-clickable"
							onClick={() => onRemoveFromPallet(dataItem)}
							data-cy={`${onRemoveFromPallet.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onChangeStatus && nonPalletizedStatus && (
						<i
							title={t('EXITSCANDETAILVIEW.TABLE.ACTION.CHANGESTATUS')}
							className="fa fa-exchange-alt k-custom-clickable"
							onClick={() => onChangeStatus(dataItem)}
							data-cy={`${onChangeStatus.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onExportToCSV && (
						<i
							title={t('EXPORTTOXLS.TITLE')}
							className="fa fa-file-export k-custom-clickable"
							onClick={() => onExportToCSV(dataItem)}
							data-cy={`${onExportToCSV.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onHold &&
						(isSeller || isSuperAdminOrganization) &&
						!isPickingMode &&
						!isBulkPrintMode &&
						holdingStatus && (
							<i
								title={t('ONHOLD')}
								className="fa fa-hand-paper k-custom-clickable"
								onClick={() => onHold(dataItem)}
								data-cy={`${onHold.name}-${dataIndex}-action`}
							></i>
						)}
					{isSuperAdminOrganization &&
						returnedActions.onCancel &&
						!isPickingMode &&
						!isBulkPrintMode &&
						onCancelStatus && (
							<i
								title={t('CANCELFULFILLMENTORDER')}
								className="fa fa-window-close k-custom-clickable"
								onClick={() => onCancel(dataItem)}
								data-cy={`${onCancel.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onChangeShipping &&
						notVendorOrder &&
						(isSeller || isSuperAdminOrganization) &&
						!isPickingMode &&
						!isBulkPrintMode &&
						nonCancelHoldReason &&
						onChangeShippingStatus && (
							<i
								title={t('CHANGESHIPPING')}
								className="fa fa-exchange-alt k-custom-clickable"
								onClick={() => onChangeShipping(dataItem)}
								data-cy={`${onChangeShipping.name}-${dataIndex}-action`}
							></i>
						)}
					{((returnedActions.onSplitFulfillmentOrder &&
						isSuperAdminOrganization &&
						dataItem.productQuantity > 1 &&
						splittingStatus) ||
						(isSuperAdminOrganization && editFulfillmentOrderSplit)) && (
						<i
							title={t(editFulfillmentOrderSplit ? 'EDITSPLITFULFILLMENTORDER' : 'SPLITFULFILLMENTORDER')}
							className="icon icon--grid-action icon--split k-custom-clickable"
							onClick={() => onSplitFulfillmentOrder(dataItem)}
							data-cy={`${onSplitFulfillmentOrder.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Void Label */}
					{returnedActions.onVoidLabel &&
						(isSeller || isSuperAdminOrganization) &&
						notVendorOrder &&
						!isPickingMode &&
						!isBulkPrintMode &&
						dataItem.activeShipmentCount != 0 &&
						dataItem.activeShipmentCount != null &&
						nonCancelHoldReason &&
						voidLabelStatus && (
							<i
								title={t('VOIDLABELVIEW.VOIDLABEL')}
								className="fa fa-undo k-custom-clickable"
								onClick={() => onVoidLabel(dataItem)}
								data-cy={`${onVoidLabel.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onStatusChange &&
						(isSeller || isSuperAdminOrganization) &&
						!isPickingMode &&
						!isBulkPrintMode &&
						onStatusChangeStatus && (
							<i
								title={t('CHANGESTATUS')}
								className="fa fa-undo k-custom-clickable"
								onClick={() => onStatusChange(dataItem)}
								data-cy={`${onStatusChange.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onPrintLabel &&
						hasPiiAccess &&
						!isPickingMode &&
						!isBulkPrintMode &&
						hasLabel &&
						nonCancelHoldReason &&
						onPrintLabelStatus && (
							<i
								title={t('PRINTLABEL')}
								className="fa fa-print k-custom-clickable"
								onClick={() => onPrintLabel(dataItem)}
								data-cy={`${onPrintLabel.name}-${dataIndex}-action`}
							></i>
						)}
					{/* Print Packing Slip */}
					{returnedActions.onPrintPackingSlip &&
						dataItem.printPackingSlip &&
						hasPiiAccess &&
						onPrintPackingSlipStatus && (
							<i
								title={t('PRINTPACKINGSLIP')}
								className="icon icon--grid-action icon--packing-slip k-custom-clickable"
								onClick={() => onPrintPackingSlip(dataItem)}
								data-cy={`${onPrintPackingSlip.name}-${dataIndex}-action`}
							></i>
						)}
					{/* Pull Label */}
					{returnedActions.onPullLabel &&
						hasPiiAccess &&
						!isPickingMode &&
						!isBulkPrintMode &&
						!hasLabel &&
						onPullLabelStatus &&
						!isBoxRequired && (
							<i
								title={t('PULLLABEL')}
								className="fas fa-arrow-alt-circle-down k-custom-clickable"
								onClick={() => onPullLabel(dataItem)}
								data-cy={`${onPullLabel.name}-${dataIndex}-action`}
							></i>
						)}
					{/* Create Return Label */}
					{returnedActions.onCreateReturnLabel &&
					_.has(dataItem, 'orderLines') &&
					dataItem.orderLines.some(ol => ol.productId) && // If productId exists, it indicates that the product is linked.
						hasPiiAccess && (
							<i
								title={t('RETURNLABEL')}
								className="fas fa-reply k-custom-clickable"
								onClick={() => onCreateReturnLabel(dataItem)}
								data-cy={`${onCreateReturnLabel.name}-${dataIndex}-action`}
							></i>
						)}
					{/* Print Return Label */}
					{returnedActions.onPrintReturnLabel && (
						<i
							title={t('PRINTLABELRETURN')}
							className="fa fa-print k-custom-clickable"
							onClick={() => onPrintReturnLabel(dataItem)}
							data-cy={`${onPrintReturnLabel.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Print Picklist */}
					{returnedActions.onPicklistPrint && (
						<i
							title={t('PRINTPICKLIST')}
							className="fa fa-file-powerpoint k-custom-clickable"
							onClick={() => onPicklistPrint(dataItem)}
							data-cy={`${onPicklistPrint.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Reoptimize */}
					{returnedActions.onReoptimize && isSuperAdminOrganization && onReoptimizeStatus && (
						<i
							title={t('REOPTIMIZE')}
							className="icon icon--grid-action icon--order-repeat k-custom-clickable"
							onClick={() => onReoptimize(dataItem)}
							data-cy={`${onReoptimize.name}-${dataIndex}-action`}
						></i>
					)}
					{/* Replace */}
					{returnedActions.onReplace &&
						_.has(dataItem, 'channel') &&
						dataItem.channel.channelType.name != channelType.amazonVendor &&
						_.has(dataItem, 'orderLines') &&
						_.some(dataItem.orderLines, orderLine => {
							return orderLine.productVirtualSkuId && orderLine.product && orderLine.product.isActive; // Replace action should be available if there is at least one order line linked to active sku.
						}) && (
							<i
								title={t('REPLACE')}
								className="fa fa-retweet k-custom-clickable"
								onClick={() => onReplace(dataItem)}
								data-cy={`${onReplace.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onNeverShipped && (isSeller || isSuperAdminOrganization) && onNeverShippedStatus && (
						<i
							title={t('NEVERSHIPPED')}
							className="icon icon--grid-action icon--never-shipped k-custom-clickable"
							onClick={() => onNeverShipped(dataItem)}
							data-cy={`${onNeverShipped.name}-${dataIndex}-action`}
						></i>
					)}
					{returnedActions.onMarkAsShipped &&
						(isSeller || isSuperAdminOrganization) &&
						!isPickingMode &&
						!isBulkPrintMode &&
						onMarkAsShippedStatus && (
							<i
								title={t('MARKASSHIPPED')}
								className="fa fa-truck k-custom-clickable"
								onClick={() => onMarkAsShipped(dataItem)}
								data-cy={`${onMarkAsShipped.name}-${dataIndex}-action`}
							></i>
						)}
					{returnedActions.onChangeOrganizationActive && (
						<i
							title={dataItem.isActive ? t('DEACTIVATE') : t('REACTIVATE')}
							className={dataItem.isActive ? 'fa fa-lock k-custom-clickable' : 'fa fa-lock-open k-custom-clickable'}
							onClick={() => onChangeOrganizationActive(dataItem)}
							data-cy={`${onChangeOrganizationActive.name}-${dataIndex}-action`}
						></i>
					)}

					{returnedActions.onResync && (
						<i
							title={t('RESYNC')}
							className="fa fa-sync k-custom-clickable"
							onClick={() => onResync(dataItem)}
							data-cy={`${onResync.name}-${dataIndex}-action`}
						></i>
					)}
				</div>
			</td>
		);
	}
}

function checkPermissions(viewStore) {
	let allowedActions = {
		actionsAllowed:
			(isSome(viewStore.tableData.actions.onDetails) && viewStore.permissions.read()) ||
			(isSome(viewStore.tableData.actions.onMarkAsShipped) && viewStore.permissions.markAsShipped()) ||
			(isSome(viewStore.tableData.actions.onEdit) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onEditOrder) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onDelete) && viewStore.permissions.remove()) ||
			(isSome(viewStore.tableData.actions.onHistory) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onPasswordChange) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onLinkOrderLine) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onRefundOrderLine) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onCancelOrder) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onCreateReturnLabel) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onAssign) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onSplit) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onChoose) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onCheck) && viewStore.permissions.update()) ||
			(isSome(viewStore.tableData.actions.onCollect) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onLabelScan) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onRemoveFromPallet) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onChangeStatus) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onHold) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onCancel) && viewStore.permissions.cancel()) ||
			(isSome(viewStore.tableData.actions.onChangeShipping) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onSplitFulfillmentOrder) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onStatusChange) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onPrintLabel) && viewStore.permissions.print()) ||
			(isSome(viewStore.tableData.actions.onPrintReturnLabel) && viewStore.permissions.print()) ||
			(isSome(viewStore.tableData.actions.onPullLabel) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onCreateReturnLabel) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onReplace) && viewStore.permissions.replace()) ||
			(isSome(viewStore.tableData.actions.onChangeOrganizationActive) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onProductActivity) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onLinkProduct) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onResync) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onPicklistPrint) && viewStore.permissions.read()) ||
			(isSome(viewStore.tableData.actions.onExportToCSV) && viewStore.permissions.read()) ||
			(isSome(viewStore.tableData.actions.onReprintLabels) && viewStore.permissions.read()) ||
			(isSome(viewStore.tableData.actions.onEditChannelWarehouseCodes) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onEditChannelCustomLabel) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onEditSeller3PLCredentials) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onEditSellerWarehouses) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onUserEdit) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onReturnAddressEdit) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onReturnAddressDelete) && viewStore.permissions.full()) ||
			(isSome(viewStore.tableData.actions.onPrintBulkHistory) && viewStore.permissions.read()),
		onDetails: isSome(viewStore.tableData.actions.onDetails) && viewStore.permissions.read(),
		onSync: isSome(viewStore.tableData.actions.onSync) && viewStore.permissions.sync(),
		onEdit: isSome(viewStore.tableData.actions.onEdit) && viewStore.permissions.update(),
		onEditOrder: isSome(viewStore.tableData.actions.onEditOrder) && viewStore.permissions.update(),
		onDelete: isSome(viewStore.tableData.actions.onDelete) && viewStore.permissions.remove(),
		onHistory: isSome(viewStore.tableData.actions.onHistory) && viewStore.permissions.full(),
		onLinkOrderLine: isSome(viewStore.tableData.actions.onLinkOrderLine) && viewStore.permissions.full(),
		onRefundOrderLine: isSome(viewStore.tableData.actions.onRefundOrderLine) && viewStore.permissions.full(),
		onCancelOrder: isSome(viewStore.tableData.actions.onCancelOrder) && viewStore.permissions.full(),
		onCreateReturnLabel: isSome(viewStore.tableData.actions.onCreateReturnLabel) && viewStore.permissions.full(),
		onPasswordChange: isSome(viewStore.tableData.actions.onPasswordChange) && viewStore.permissions.update(),
		onAssign: isSome(viewStore.tableData.actions.onAssign) && viewStore.permissions.update(),
		onSplit: isSome(viewStore.tableData.actions.onSplit) && viewStore.permissions.full(),
		onChoose: isSome(viewStore.tableData.actions.onChoose) && viewStore.permissions.update(),
		onCheck: isSome(viewStore.tableData.actions.onCheck) && viewStore.permissions.update(),
		onCollect: isSome(viewStore.tableData.actions.onCollect && viewStore.permissions.full()),
		onLabelScan: isSome(viewStore.tableData.actions.onLabelScan) && viewStore.permissions.full(),
		onRemoveFromPallet: isSome(viewStore.tableData.actions.onRemoveFromPallet) && viewStore.permissions.full(),
		onChangeStatus: isSome(viewStore.tableData.actions.onChangeStatus) && viewStore.permissions.full(),
		onHold: isSome(viewStore.tableData.actions.onHold) && viewStore.permissions.full(),
		onCancel: isSome(viewStore.tableData.actions.onCancel) && viewStore.permissions.cancel(),
		onChangeShipping: isSome(viewStore.tableData.actions.onChangeShipping) && viewStore.permissions.full(),
		onSplitFulfillmentOrder:
			isSome(viewStore.tableData.actions.onSplitFulfillmentOrder) && viewStore.permissions.full(),
		onStatusChange: isSome(viewStore.tableData.actions.onStatusChange) && viewStore.permissions.full(),
		onPrintLabel: isSome(viewStore.tableData.actions.onPrintLabel) && viewStore.permissions.print(),
		onPrintPackingSlip: isSome(viewStore.tableData.actions.onPrintPackingSlip) && viewStore.permissions.print(),
		onPrintReturnLabel: isSome(viewStore.tableData.actions.onPrintReturnLabel) && viewStore.permissions.print(),
		onPullLabel: isSome(viewStore.tableData.actions.onPullLabel) && viewStore.permissions.full(),
		onCreateReturnLabel: isSome(viewStore.tableData.actions.onCreateReturnLabel) && viewStore.permissions.full(),
		onReplace: isSome(viewStore.tableData.actions.onReplace) && viewStore.permissions.full(),
		onNeverShipped: isSome(viewStore.tableData.actions.onNeverShipped) && viewStore.permissions.update(),
		onMarkAsShipped: isSome(viewStore.tableData.actions.onMarkAsShipped) && viewStore.permissions.markAsShipped(),
		onReoptimize: isSome(viewStore.tableData.actions.onReoptimize) && viewStore.permissions.onReoptimize(),
		onChangeOrganizationActive:
			isSome(viewStore.tableData.actions.onChangeOrganizationActive) && viewStore.permissions.full(),
		onProductActivity: isSome(viewStore.tableData.actions.onProductActivity) && viewStore.permissions.full(),
		onLinkProduct: isSome(viewStore.tableData.actions.onLinkProduct) && viewStore.permissions.full(),
		onResync: isSome(viewStore.tableData.actions.onResync) && viewStore.permissions.full(),
		onPicklistPrint: isSome(viewStore.tableData.actions.onPicklistPrint) && viewStore.permissions.read(),
		onExportToCSV: isSome(viewStore.tableData.actions.onExportToCSV) && viewStore.permissions.read(),
		onPrintLabel: isSome(viewStore.tableData.actions.onPrintLabel) && viewStore.permissions.read(),
		onVoidLabel: isSome(viewStore.tableData.actions.onVoidLabel) && viewStore.permissions.voidLabel(),
		onPrintBulkHistory: isSome(viewStore.tableData.actions.onPrintBulkHistory) && viewStore.permissions.read(),
		onReprintLabels: isSome(viewStore.tableData.actions.onReprintLabels) && viewStore.permissions.read(),
		onUserEdit: isSome(viewStore.tableData.actions.onUserEdit) && viewStore.permissions.full(),
		onReturnAddressEdit: isSome(viewStore.tableData.actions.onReturnAddressEdit) && viewStore.permissions.full(),
		onReturnAddressDelete: isSome(viewStore.tableData.actions.onReturnAddressDelete) && viewStore.permissions.full(),
		onEditChannelWarehouseCodes:
			isSome(viewStore.tableData.actions.onEditChannelWarehouseCodes) && viewStore.permissions.full(),
		onEditChannelCustomLabel:
			isSome(viewStore.tableData.actions.onEditChannelCustomLabel) && viewStore.permissions.full(),
		onEditSeller3PLCredentials:
			isSome(viewStore.tableData.actions.onEditSeller3PLCredentials) && viewStore.permissions.full(),
		onEditSellerWarehouses: isSome(viewStore.tableData.actions.onEditSellerWarehouses) && viewStore.permissions.full(),
	};

	return allowedActions;
}

const CheckboxCellData = ({ dataItem, onClick, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return (
		<td colSpan="1" className="k-custom-frozen">
			<BaasicCheckbox
				className="input--check input--check--no-label"
				id={'bulk-' + dataItem.id}
				onChange={() => onClick(dataItem.id)}
				checked={dataItem.isChecked}
			/>
		</td>
	);
};

const UsernameCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const data = _.get(dataItem, field);
	return <td colSpan="1">{data && data.split('-')[0]}</td>;
};

const HistoryPropertyCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const data = _.concat(_.map(dataItem.changed, val => [val[field]]));
	return (
		<td>
			<table>
				<tbody>
					{_.map(data, (item, idx) => {
						return (
							<tr key={idx}>
								<td>{item.length === 1 && item[0] === '' ? '/' : item}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</td>
	);
};

const TooltipDateTimeCellData = ({
	dataItem,
	field,
	dateFormat,
	isClickable,
	rowType,
	newPropertyToUse,
	translationKey,
	t,
}) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const locale = window.navigator.userLanguage || window.navigator.language;
	moment.locale(locale);
	const localeData = moment.localeData();
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const format = dateFormat ? dateFormat : localeData.longDateFormat('L');
	const displayTooltip = _.get(dataItem, newPropertyToUse) != null;
	const dateToUse = displayTooltip ? _.get(dataItem, newPropertyToUse) : _.get(dataItem, field);
	const dateTime =
		dateToUse != null
			? moment(dateToUse)
					.tz(timezone)
					.format(format)
			: '-';
	return (
		<td colSpan="1" className={isClickable ? 'k-custom-clickable' : undefined}>
			{dateTime}
			{displayTooltip && (
				<React.Fragment>
					<i
						data-tip={t(translationKey, {
							date:
								_.get(dataItem, field) != null
									? moment(_.get(dataItem, field))
											.tz(timezone)
											.format(format)
									: '-',
						})}
						className="spc--left--tny fas fa-exclamation-circle"
					/>
				</React.Fragment>
			)}
		</td>
	);
};

const DateTimeCellData = ({ dataItem, field, dateFormat, useLocalTime, isClickable, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const locale = window.navigator.userLanguage || window.navigator.language;
	moment.locale(locale);
	const localeData = moment.localeData();
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const format = dateFormat ? dateFormat : localeData.longDateFormat('L');
	const dateTime = _.get(dataItem, field)
		? useLocalTime
			? moment(
					moment
						.utc(_.get(dataItem, field))
						.toDate()
						.toLocaleString()
			  ).format(format)
			: moment(_.get(dataItem, field))
					.tz(timezone)
					.format(format)
		: '-';

	return (
		<td colSpan="1" className={isClickable ? 'k-custom-clickable' : undefined}>
			{dateTime}
		</td>
	);
};

const ProductActivityCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	let data = null;
	if ((field === 'quantity' || field === 'warehouseOnHoldQuantity') && dataItem[field] != null && dataItem[field] > 0) {
		data = `+${dataItem[field]}`;
	} else {
		data = dataItem[field] !== null && dataItem[field] !== '' ? dataItem[field] : '-';
	}

	return <td colSpan="1">{data}</td>;
};

const DatetimeFromShippingInfoCellData = ({ dataItem, dateFormat, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const haveActiveShipments =
		_.find(dataItem.shipmentInfos, item => {
			return item.shipmentInfoStatus.abrv == 'active';
		}) ||
		(isSome(dataItem.activeShipmentCount) && dataItem.activeShipmentCount > 0);
	const haveInactiveShipment =
		_.find(dataItem.shipmentInfos, item => {
			return item.shipmentInfoStatus.abrv != 'active';
		}) ||
		(isSome(dataItem.inactiveShipmentCount) && dataItem.inactiveShipmentCount > 0);

	const locale = window.navigator.userLanguage || window.navigator.language;
	moment.locale(locale);
	const localeData = moment.localeData();
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const format = dateFormat ? dateFormat : localeData.longDateFormat('L');

	const shippingDateTime = isSome(dataItem.shippingDateTime)
		? dataItem.shippingDateTime
		: isSome(dataItem.shippingDate)
		? dataItem.shippingDate
		: null;

	if (haveActiveShipments) {
		const dateTime = shippingDateTime
			? moment(shippingDateTime)
					.tz(timezone)
					.format(format)
			: '-';
		return <td colSpan="1">{dateTime}</td>;
	} else {
		if (haveInactiveShipment != null) {
			const dateTime = shippingDateTime
				? moment(shippingDateTime)
						.tz(timezone)
						.format(format)
				: '-';
			return (
				<td colSpan="1" className="inactive-shipment">
					{dateTime}
				</td>
			);
		} else return <td colSpan="1">{''}</td>;
	}
};

const StatusCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return (
		<td colSpan="1" className="type--center">
			{dataItem[field] ? (
				<i
					title={translate([dataItem[field], { name: dataItem.name }])}
					className="type--color--note fa fa-exclamation-circle"
				/>
			) : (
				<i title={translate('CHANNEL.STATUSOK')} className="type--color--success fa fa-check-circle " />
			)}
		</td>
	);
};

const CurrencyCellData = ({ dataItem, field, currencySign, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return (
		<td colSpan="1" className="k-custom-clickable">
			{`${currencySign}${formatCurrency(dataItem[field])}`}
		</td>
	);
};

const ChargesCellData = ({ dataItem, field, formatter, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return <td colSpan="1">{formatter.format(dataItem[field])}</td>;
};

const ChargesDifferenceCellData = ({ dataItem, field, rowType, formatter }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const value = _.get(dataItem, field);
	if (value == null) return <td colSpan="1">{'-'}</td>;
	else if (value == 0) {
		return <td colSpan="1">{formatter.format(value)}</td>;
	} else if (value < 0) {
		return (
			<td colSpan="1" className="type--color--success">
				{formatter.format(value)}
			</td>
		);
	} else {
		return (
			<td colSpan="1" className="type--color--warning">
				{`+${formatter.format(value)}`}
			</td>
		);
	}
};

const DescriptionCellData = ({ dataItem, field, maxChars, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const description = _.get(dataItem, field);
	const showTooltip = description.length > maxChars || description.length > 30;
	return (
		<td colSpan="1" title={showTooltip ? description : undefined}>
			{description && description.substr(0, maxChars ? maxChars : 30) + `${showTooltip ? '\u2026' : ''}`}
		</td>
	);
};

const PalletCellData = ({ dataItem, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	if (_.has(dataItem, 'activeShipmentCount') && _.has(dataItem, 'inactiveShipmentCount')) {
		const haveActiveShipments = isSome(dataItem.activeShipmentCount) && dataItem.activeShipmentCount > 0;
		const haveInactiveShipments = isSome(dataItem.inactiveShipmentCount) && dataItem.inactiveShipmentCount > 0;

		if (haveActiveShipments) {
			return <td colSpan="1">{dataItem.pallet}</td>;
		} else {
			return (
				<td colSpan="1" className="inactive-shipment">
					{haveInactiveShipments ? dataItem.pallet : ''}
				</td>
			);
		}
	} else {
		const activeShipment = _.find(dataItem.shipmentInfos, item => {
			return item.shipmentInfoStatus.abrv == 'active' && item.pallet != null;
		});
		const notActiveShipment = _.find(dataItem.shipmentInfos, item => {
			return item.shipmentInfoStatus.abrv != 'active' && item.pallet != null;
		});

		if (activeShipment) {
			return <td colSpan="1">{activeShipment.pallet.name}</td>;
		} else {
			return (
				<td colSpan="1" className="inactive-shipment">
					{notActiveShipment != null ? notActiveShipment.pallet.name : ''}
				</td>
			);
		}
	}
};

const BulkPrintHistoryFOrders = ({ dataItem }) => {
	var fotext = '';
	if (dataItem.bulkPrintHistoryItems.length >= 1)
		dataItem.bulkPrintHistoryItems.forEach((element, idx) => {
			fotext += element.fulfillmentOrder.fulfillmentOrderId;
			fotext += idx != dataItem.bulkPrintHistoryItems.length - 1 ? ' - ' : '';
		});
	else fotext = translate('FULFILLMENTORDER.BULKPRINT.NOITEMSINBULK');
	return <td colSpan="1">{fotext}</td>;
};

const TimeCellData = ({ dataItem, fromFormat, toFormat, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	let data = dataItem.cutoffTimeStart
		? moment(dataItem.cutoffTimeStart, fromFormat).format(toFormat)
		: moment(dataItem.cutoffTimeEnd, fromFormat).format(toFormat);

	return <td colSpan="1">{data}</td>;
};

const CarrierDeliveryStatusCellData = ({ dataItem, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	if (_.has(dataItem, 'deliveryStatus')) {
		const hasInactiveShipment = isSome(dataItem.inactiveShipmentCount) && dataItem.inactiveShipmentCount > 0;
		return (
			<td colSpan="1" className={hasInactiveShipment ? 'inactive-shipment' : ''}>
				{dataItem.deliveryStatus != null ? dataItem.deliveryStatus : ''}
			</td>
		);
	} else {
		const activeShipment = _.find(dataItem.shipmentInfos, item => {
			return item.shipmentInfoStatus.abrv == 'active';
		});
		return (
			<td colSpan="1">
				{activeShipment != null && activeShipment.carrierDeliveryStatus != null
					? activeShipment.carrierDeliveryStatus.name
					: ''}
			</td>
		);
	}
};

const ZoneCellData = ({ dataItem, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return <td colSpan="1">{dataItem.activeShipmentCount > 0 ? dataItem.zone : ''}</td>;
};

const MultipleCellData = ({ dataItem, field, rowType, isOrderLineView }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	let data = null;
	if (isOrderLineView) {
		if (dataItem.product != null && dataItem.product.productUpcs != null) {
			data = dataItem.product.productUpcs.length > 1 ? 'Multiple' : dataItem.product.productUpcs[0].upc;
		}
	} else if (field == 'orderLines.quantity') {
		data = _.sumBy(_.get(dataItem, field.split('.')[0]), 'quantity');
	} else {
		const objectKey = field.split('.')[0];
		const propertyKey = field.split('.').pop();

		if (dataItem[objectKey].length != 0) {
			if (dataItem[objectKey].length != 1) {
				data = 'Multiple';
			} else {
				data = dataItem[objectKey][0][propertyKey];
			}
		}
	}

	return <td colSpan="1">{data}</td>;
};

const QuantityPerSkuCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	return (
		<td colSpan="1">
			<ul>
				{_.get(dataItem, field) ? (
					_.map(_.get(dataItem, field).split(','), value => {
						return <li key={value}>{value}</li>;
					})
				) : (
					<li>{'-'}</li>
				)}
			</ul>
		</td>
	);
};

const ImageCellData = props => {
	return (
		<td colSpan="1">
			<img
				className="order__image order__image--sml spc--right--sml"
				src="https://milliardbedding.com/wp-content/uploads/2021/04/51104088640_40f294f443_o-scaled-700x700.jpg"
			></img>
		</td>
	);
};

const BooleanToggleCellData = ({ dataItem, field, onClick, trueValue, rowType, dataIndex }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const colName = `${dataItem.id}_${field}`;
	const fieldValue = _.get(dataItem, field);
	if (dataItem.channelType == null ? true : dataItem.channelType.abrv != 'manual%20orders') {
		return (
			<td colSpan="1" className={onClick ? 'k-custom-clickable' : undefined}>
				<input
					onClick={() => onClick(dataItem, field)}
					data-cy={`${field.replaceAll('.', '-')}-${dataIndex}-toggle`}
					className={'input--toggle'}
					type="checkbox"
					id={colName}
					checked={isSome(trueValue) ? fieldValue === trueValue : fieldValue}
					readOnly={true}
				/>
				<label htmlFor={colName} data-cy={`${field.replaceAll('.', '-')}-${dataIndex}-toggle-label`}>
					&nbsp;
				</label>
			</td>
		);
	} else {
		return <td colSpan="1"></td>;
	}
};

const BooleanCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const selectedProperty = _.get(dataItem, field);
	return (
		<td colSpan="1" className="type--center">
			{field === 'primeOrder' || field === 'isPrime' ? (
				isSome(selectedProperty) ? (
					selectedProperty ? (
						<i className="icon icon--xlrg icon--prime" />
					) : (
						<i className="icon icon--xlrg icon--prime--grey" />
					)
				) : null
			) : isSome(selectedProperty) ? (
				selectedProperty ? (
					<i className="type--color--success fas fa-check-circle" />
				) : (
					<i className="fas fa-times-circle type--color-grey-5" />
				)
			) : null}
		</td>
	);
};

const BuyerRequestedCancelCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const objectKey = field.split('.')[0];
	const selectedProperty = _.has(dataItem, objectKey)
		? dataItem.orderLines && dataItem.orderLines.length != 0
			? _.some(dataItem.orderLines, item => {
					return item.isBuyerRequestedCancel == true;
			  })
			: null
		: null;

	return (
		<td colSpan="1" className="type--center">
			{isSome(selectedProperty) ? (
				selectedProperty ? (
					<i className="type--color--success fas fa-check-circle" />
				) : (
					<i className="fas fa-times-circle type--color-grey-5" />
				)
			) : null}
		</td>
	);
};
const HyperLinkOrderNumberCellData = ({ field, dataItem, isWarehouse }) => {
	const data = _.get(dataItem, field);
	if (dataItem.orderChannelType == channelType.amazon && !isWarehouse) {
		return (
			<td>
				<a href={'https://sellercentral.amazon.com/orders-v3/order/' + data} target="_blank">
					{data}
				</a>
			</td>
		);
	} else {
		return <td>{data}</td>;
	}
};

const HyperLinkTrackingNumberCellData = ({
	field,
	dataItem,
	carrierServicePath,
	checkForMultiple,
	shipmentStatusPath,
	locked,
}) => {
	let data = dataItem;
	let carrierService = null;
	carrierService = _.has(dataItem, carrierServicePath) ? _.get(dataItem, carrierServicePath).toUpperCase() : null;
	if (checkForMultiple) {
		const foObjectKey = field.split('.')[0];
		data = undefined;
		if (isSome(dataItem[foObjectKey]) && dataItem[foObjectKey].length != 0) {
			let shipmentInfos = [];
			_.forEach(dataItem[foObjectKey], item => {
				if (isSome(item.shipmentInfos) && item.shipmentInfos.length > 0) {
					shipmentInfos.push(item.shipmentInfos[0]);
				}
			});
			if (isSome(shipmentInfos) && shipmentInfos.length > 0) {
				if (shipmentInfos.length > 1) {
					return <td>{'Multiple'}</td>;
				} else {
					data = shipmentInfos[0].trackingNumber;
				}
			}
		}
	} else {
		const paths = field.split('.');
		if (paths.length > 1) {
			_.each(paths, path => {
				data = _.get(data, path);
				if (data == null) {
					return <td></td>;
				}
				if (isArray(data)) {
					data = data[0];
				}
			});
		} else {
			data = _.get(dataItem, field);
		}
	}
	var hyperlinkStyle =
		shipmentStatusPath != null && dataItem[shipmentStatusPath] == 'voided' ? 'inactive-shipment' : null;
	let styleWithLock = locked ? 'k-custom-frozen ' + hyperlinkStyle : hyperlinkStyle;
	return (
		<td className={styleWithLock}>
			{carrierService != null && data != null ? (
				<a
					href={
						carrierService.includes('USPS') || carrierService.includes('STAMPS')
							? `https://www.stamps.com/tracking-details/?t=${data}`
							: carrierService.includes('FEDEX')
							? `https://www.fedex.com/apps/fedextrack/?action=track&language=english&tracknumbers=${data}`
							: `https://www.ups.com/track?loc=en_US&requester=QUIC&tracknum=${data.split('-')[0]}`
					}
					target="_blank"
				>
					{data}
				</a>
			) : (
				<React.Fragment>{data}</React.Fragment>
			)}
		</td>
	);
};

const HyperlinkCellData = ({
	onClick,
	expandable,
	t,
	field,
	locked,
	translation,
	propertyToCheck,
	showSelectAllColumn,
	dataItem,
	rowType,
}) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const isMultiItem = _.has(dataItem, 'orderedItemCount') ? dataItem.orderedItemCount > 1 : null;
	const wmsOriginated = _.has(dataItem, 'wmsOriginated') ? dataItem.wmsOriginated : null;
	let keys = field.split('.');
	let data = _.get(dataItem, field);
	let isReplacement = dataItem.deliveryReplacement != null && dataItem.deliveryReplacement === true;
	let addressChanged = dataItem.addressChanged != null && dataItem.addressChanged === true;
	let showSplitIcon = false;
	let showMultiItemIcon = isMultiItem || (_.has(dataItem, 'productQuantity') && dataItem.productQuantity > 1);
	let isReentered;
	let isMissingBilledRate = dataItem.missingBilledRateCount != null ? dataItem.missingBilledRateCount > 0 : null;
	if (_.has(dataItem, 'fulfillmentOrderNewShipByDate') && _.has(dataItem, 'fulfillmentOrderShipByDateTime')) {
		isReentered =
			dataItem.fulfillmentOrderNewShipByDate > dataItem.fulfillmentOrderShipByLocalDate ||
			dataItem.fulfillmentOrderNewShipByDate == dataItem.fulfillmentOrderShipByLocalDate;
	}

	if (keys.length != 1) {
		keys.pop();
		dataItem = _.get(dataItem, keys.join('.'));
	}
	if (_.has(dataItem, 'orderLines')) {
		var hasUnlinkedOrderLine = _.find(dataItem.orderLines, orderLine => {
			if (orderLine.productId == null) {
				return true;
			}
		});
	}
	if (_.has(dataItem, 'shippingCoreCountry') || _.has(dataItem, 'shippingCoreCountryState')) {
		const shippingCoreCountry = _.get(dataItem, 'shippingCoreCountry');
		const shippingCoreCountryState = _.get(dataItem, 'shippingCoreCountryState');
		if ((shippingCoreCountryState == null || shippingCoreCountry == null) && dataItem.orderStatus.abrv == 'unshipped') {
			const orderDateCreated = new Date(dataItem.dateCreated);
			if (new Date().getTime() - orderDateCreated.getTime() < 30 * 24 * 60 * 60 * 1000) {
				var missingDataWarning = true;
			}
		}
	}

	if (_.has(dataItem, 'isSplit') || _.has(dataItem, 'isCreatedBySplit')) {
		if (dataItem.isSplit || (dataItem.isCreatedBySplit && dataItem.originalFulfillmentOrderIdInt)) {
			showSplitIcon = true;
		}
	}

	if (translation != null && propertyToCheck != null) {
		var showWarning = dataItem[propertyToCheck] != null;
	}
	return (
		<td
			colSpan="1"
			className={
				locked
					? expandable
						? 'k-custom-frozen k-custom-frozen--expand'
						: showSelectAllColumn
						? 'k-custom-frozen k-custom-frozen--checkboxexpand'
						: 'k-custom-frozen'
					: null
			}
		>
			<div className="flex--primary">
				{isSome(data) ? (
					field === 'productQuantityPerSku' ? (
						<ul>
							{data.split(';').map(value => {
								const productId = _.find(dataItem.productIds.split(','), item => {
									return item.includes(value.split(':')[0]);
								});
								if (productId != null) {
									return (
										<li key={value}>
											<a onClick={() => onClick(productId.split(';')[0])}>{value}</a>
										</li>
									);
								} else {
									return <li key={value}>{value}</li>;
								}
							})}
						</ul>
					) : (
						<a onClick={() => onClick(dataItem)}>{data}</a>
					)
				) : (
					<p>
						<em>{t('PRODUCTNOTLINKED')}</em>
					</p>
				)}
				{hasUnlinkedOrderLine && (
					<i data-tip={t('ORDERVIEW.UNLINKEDORDERLINES')} className="push spc--left--tny fas fa-exclamation-circle" />
				)}
				{missingDataWarning && (
					<i data-tip={t('ORDERVIEW.MISSINGDATA')} className="push spc--left--tny fas fa-question-circle" />
				)}
				{showSplitIcon &&
					field == 'fulfillmentOrderId' &&
					(dataItem.isSplit ? (
						<i data-tip={t('ORDERVIEW.ISSPLIT')} className="icon icon--grid-action icon--split spc--left--tny" />
					) : (
						<i
							data-tip={t('ORDERVIEW.CREATEDFROMSPLIt', {
								fulfillmentOrderId: dataItem.originalFulfillmentOrderIdInt,
							})}
							className="icon icon--grid-action icon--split spc--left--tny"
						/>
					))}
				{showWarning && <i data-tip={t('ORDERVIEW.ONHOLD')} className="spc--left--tny fas fa-exclamation-circle" />}
				{wmsOriginated && (
					<i data-tip={t('RECEIVINGVIEW.WMSORIGINATED')} className="spc--left--tny fas fa-exclamation-circle" />
				)}
				{isReplacement && field == 'fulfillmentOrderId' && (
					<i
						data-tip={t('ORDERVIEW.REPLACEMENT')}
						className="icon icon--grid-action icon--replacement spc--left--tny"
					/>
				)}
				{isReentered && field == 'fulfillmentOrderId' && (
					<i data-tip={t('ORDERVIEW.REENTERED')} className="fa fa-undo spc--left--tny" />
				)}
				{addressChanged && field == 'fulfillmentOrderId' && (
					<i
						data-tip={t('ORDERVIEW.ADDRESSCHANGED')}
						className="icon icon--grid-action icon--location-check spc--left--nano"
					></i>
				)}
				{addressChanged && field == 'orderNumber' && (
					<i
						data-tip={t('MARKETPLACEORDERS.ADDRESSCHANGED')}
						className="icon icon--grid-action icon--location-check spc--left--nano"
					></i>
				)}
				{showMultiItemIcon && field == 'fulfillmentOrderId' && (
					<i
						data-tip={t('ORDERVIEW.MULTIITEM')}
						className="icon icon--grid-action icon--multi-item-box spc--left--tny"
					></i>
				)}
				{isMissingBilledRate && field == 'name' && (
					<i
						data-tip={t('SHIPMENTCOST.MISSINGBILLEDRATE', {
							count: dataItem.missingBilledRateCount,
						})}
						className="spc--left--tny fas fa-exclamation-circle"
					/>
				)}
			</div>
		</td>
	);
};

const InventoryDataCell = ({ dataItem, field, isTotalQuantityColumn, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const data = _.get(dataItem, field).toString();
	const showTooltip = isTotalQuantityColumn ? data.length >= 6 : data.length >= 4;
	return (
		<td
			data-tip={showTooltip ? data : null}
			style={
				isSome(isTotalQuantityColumn)
					? { textAlign: 'center', color: 'orange', fontWeight: 'bolder', fontSize: 18 }
					: { textAlign: 'center', color: 'grey', fontSize: 12 }
			}
			colSpan="1"
		>
			{data}
		</td>
	);
};

const ProductHyperLinkCellData = ({ onClick, expandable, t, locked, field, dataItem, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const data = _.get(dataItem, field);
	const productVirtualSku = _.find(dataItem.productVirtualSkus, productVirtualSku => {
		return productVirtualSku.channel.channelType.name === channelType.amazon && !productVirtualSku.isDeleted;
	});

	let productInventoryRestockDate =
		dataItem.productInventoryRestockDate != null
			? dataItem.productInventoryRestockDate
			: productVirtualSku != null
			? productVirtualSku.channel.productInventoryRestockDate
			: null;

	let scheduledRestockDateNote =
		productInventoryRestockDate != null &&
		productInventoryRestockDate.restockDate != null &&
		!isCurrentDateGreater(productInventoryRestockDate.restockDate)
			? productInventoryRestockDate.scheduledRestockDateTime
			: null;

	if (scheduledRestockDateNote != null) {
		scheduledRestockDateNote = formatDate(scheduledRestockDateNote, true, 'LLL');
	}

	return (
		<td
			colSpan="1"
			className={locked ? (expandable ? 'k-custom-frozen k-custom-frozen--expand' : 'k-custom-frozen') : null}
		>
			<div className="flex--secondary">
				{isSome(dataItem) ? (
					<a onClick={() => onClick(dataItem)}>{data}</a>
				) : (
					<p>
						<em>{t('PRODUCTMAINSKUMISSING')}</em>
					</p>
				)}
				{!isSome(dataItem.box) && <i data-tip={t('PRODUCTBOXMISSING')} className="push spc--left--tny fas fa-box" />}
				{isSome(scheduledRestockDateNote) && (
					<i
						data-tip={t('RESTOCKDATE.SCHEDULEDRESTOCKDATENOTE', { scheduledDate: scheduledRestockDateNote })}
						className="far fa-clock type--color--success"
					/>
				)}
			</div>
		</td>
	);
};

const ProductHistoryLogSkuCellData = ({ t, field, dataItem, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const data = _.get(dataItem, field);
	return (
		<td>
			<span>{data}</span>
			{!isSome(dataItem.product.box) && <i data-tip={t('PRODUCTBOXMISSING')} className="spc--left--tny fas fa-box" />}
		</td>
	);
};

const ButtonCellData = ({ dataItem, onClick, t, translation, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return (
		<td colSpan="1">
			<button className="btn btn--med btn--primary" type="submit" onClick={() => onClick(dataItem)}>
				{t(translation)}
			</button>
		</td>
	);
};

const IconCellData = ({ dataItem, field, t, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	let data = _.get(dataItem, field);
	let scheduledRestockDateNote = _.has(dataItem, 'productInventoryRestockDate')
		? dataItem.productInventoryRestockDate != null &&
		  dataItem.productInventoryRestockDate.restockDate != null &&
		  !isCurrentDateGreater(dataItem.productInventoryRestockDate.restockDate)
			? dataItem.productInventoryRestockDate.scheduledRestockDateTime
			: null
		: null;
	if (scheduledRestockDateNote != null) {
		scheduledRestockDateNote = formatDate(scheduledRestockDateNote, true, 'LLL');
	}
	return (
		<td colSpan="1">
			<div className="flex--secondary">
				{data}
				{scheduledRestockDateNote && (
					<i
						data-tip={t('RESTOCKDATE.SCHEDULEDRESTOCKDATENOTE', { scheduledDate: scheduledRestockDateNote })}
						className="spc--left--tny type--color--success far fa-clock"
					/>
				)}
			</div>
		</td>
	);
};

const ShippingCostCellData = ({ dataItem, rowType, field }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const shippingCost = _.get(dataItem, field);
	return (
		<td colSpan="1">
			{isSome(shippingCost) ? (
				dataItem.shippingCostSurcharge != 0 ? (
					<React.Fragment>
						<p className="order__highlight">{`$${dataItem.shippingCostTotal}`}</p>
						<CostBreakdownTooltip
							idValue={dataItem.id}
							shippingCost={shippingCost}
							surplusCharge={dataItem.shippingCostSurcharge}
							total={dataItem.shippingCostTotal}
							displayIcon={true}
						/>
					</React.Fragment>
				) : (
					<p>{shippingCost}</p>
				)
			) : null}
		</td>
	);
};

const ContainerProductHyperlinkCellData = ({ dataItem, field, onClick, expandable, t, locked, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	const data = _.get(dataItem, field);
	return (
		<td
			colSpan="1"
			className={locked ? (expandable ? 'k-custom-frozen k-custom-frozen--expand' : 'k-custom-frozen') : null}
		>
			{isSome(data) ? (
				<a onClick={() => onClick(dataItem.productId)}>{data}</a>
			) : (
				<p>
					<em>{t('PRODUCTMAINSKUMISSING')}</em>
				</p>
			)}
		</td>
	);
};

const FulfillmentOrderIdHyperlinkCellData = ({ dataItem, onClick, expandable, t, locked, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}
	let isReplacement = dataItem.deliveryReplacement != null && dataItem.deliveryReplacement === true;
	return (
		<td
			colSpan="1"
			className={locked ? (expandable ? 'k-custom-frozen k-custom-frozen--expand' : 'k-custom-frozen') : null}
		>
			{isSome(dataItem) ? (
				<a onClick={() => onClick(dataItem)}>{dataItem.fulfillmentOrderId}</a>
			) : (
				<p>
					<em>{t('ORDERIDMISSING')}</em>
				</p>
			)}
			{isReplacement && (
				<i data-tip={t('ORDERVIEW.REPLACEMENT')} className="icon icon--grid-action icon--replacement spc--left--tny" />
			)}
		</td>
	);
};

const OrderLinesHyperlinkCellData = ({ dataItem, onClick, expandable, t, locked, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	return (
		<td
			colSpan="1"
			className={locked ? (expandable ? 'k-custom-frozen k-custom-frozen--expand' : 'k-custom-frozen') : null}
		>
			{isSome(dataItem.product) ? (
				<a onClick={() => onClick(dataItem.product)}>{dataItem.sku}</a>
			) : (
				<p>
					{dataItem.sku}
					<i
						data-tip={t('ORDERLINEVIEW.UNLINKEDORDERLINE')}
						className="push spc--left--tny fas fa-exclamation-circle"
					/>
				</p>
			)}
		</td>
	);
};

const PasswordExpirationCellData = ({ dataItem, field, t }) => {
	const passwordChangeDate = new Date(_.get(dataItem, field)).setHours(0, 0, 0, 0);
	const dateTimeNow = new Date().setHours(0, 0, 0, 0);
	const difference = dateTimeNow - passwordChangeDate;
	const daysUntilExpiration = 365 - Math.floor(difference / (1000 * 3600 * 24));
	const suffix = daysUntilExpiration == 1 ? 'day' : 'days';
	return <td colSpan="1">{daysUntilExpiration <= 0 ? t('EXPIRED') : `${daysUntilExpiration} ${suffix}`}</td>;
};

const WeightCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	if (dataItem.weightUnit.abrv === 'pounds%20and%20ounces') {
		const pounds = parseInt(dataItem[field] / 1);
		const ounces = (dataItem[field] % 1) * conversionRates.poundsAndOunces;
		return (
			<td colSpan="1">
				{`${pounds} lb`} {ounces != 0 && `/ ${ounces} oz`}
			</td>
		);
	}
	return <td colSpan="1">{`${dataItem[field]} kg`}</td>;
};

const DropdownCellData = props => {
	const {
		dataItem,
		service,
		searchBy,
		ids,
		warehouseOnly,
		includeOnlySellerWarehouses,
		sellerWarehousesOnlyOrganizationId,
		selectedValueField,
		updateDataItem,
		idsToExclude,
		fetcWithoutInventory,
		dataName,
		viewStore,
	} = props;

	const arrayIdx = _.findIndex(viewStore[dataName], item => item === dataItem);

	return (
		<td>
			<BaasicAsyncCreatableSelect
				clearable={true}
				creatable={false}
				service={service}
				searchBy={searchBy}
				selectedValue={selectedValueField ? dataItem[selectedValueField] : null}
				ids={ids}
				warehouseOnly={warehouseOnly}
				includeOnlySellerWarehouses={includeOnlySellerWarehouses}
				sellerWarehousesOnlyOrganizationId={sellerWarehousesOnlyOrganizationId}
				isDisabled={!dataItem.inEdit || dataItem.id}
				updateDataItem={updateDataItem}
				arrayIdx={arrayIdx}
				idsToExclude={idsToExclude}
				fetcWithoutInventory={fetcWithoutInventory}
			/>
		</td>
	);
};

const RateCellData = ({ dataItem, field, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const assignedRate = _.get(dataItem, field);
	return (
		<td colSpan="1">
			{isSome(assignedRate) ? (
				!(dataItem.assignedRateSurcharge == null || dataItem.assignedRateSurcharge == 0) ? (
					<React.Fragment>
						<p className="order__highlight">{`$${dataItem.assignedRateTotal}`}</p>
						<CostBreakdownTooltip
							idValue={`rate-${dataItem.id}`}
							shippingCost={assignedRate}
							surplusCharge={dataItem.assignedRateSurcharge}
							total={dataItem.assignedRateTotal}
							displayIcon={true}
						/>
					</React.Fragment>
				) : (
					<p>{assignedRate}</p>
				)
			) : null}
		</td>
	);
};

const OnTableFilter = (evt, onTableFilter, column) => {
	evt.stopPropagation();
	onTableFilter(column, evt.currentTarget.parentNode.childNodes[1]);
};

const BulkPrintHistoryNameTooltipCellData = props => {
	const { dataItem, field } = props;
	const description = _.get(dataItem, field);
	const showTooltip = dataItem.name.length > 25;
	return (
		<td colSpan="1">
			<p data-tip={showTooltip ? description : undefined} className={showTooltip ? 'type--ellipsis' : null}>
				{dataItem.name}
			</p>
		</td>
	);
};

const BaasicHeaderCellData = ({ column, t, viewStore }) => {
	const headerProps = {};
	let sortArrow = '';

	if (viewStore && viewStore.queryUtility) {
		if (viewStore.queryUtility.filter.orderDirection === 'asc') {
			sortArrow = 'up';
		}
		if (viewStore.queryUtility.filter.orderDirection === 'desc') {
			sortArrow = 'down';
		}
	}

	if (viewStore && column.sortable && (viewStore.queryUtility || viewStore.allList)) {
		if (viewStore.allList) {
			headerProps.onClick = () => viewStore.onAllLookupSort();
		} else {
			headerProps.onClick = () => viewStore.queryUtility.changeOrder(column);
		}
	}

	let className = 'table__head--data';
	if (isSome(column.locked)) {
		className += ' frozen';
	}

	return (
		<section {...headerProps} key={column.key} className={className}>
			<div className={'table__head--iconwrap'}>
				{column.filterType ? (
					<i
						className={
							'fas fa-filter type--sml cursor--pointer spc--right--tny' +
							(column.filter ? ' type--color--secondary k-filtered-column' : '')
						}
						onClick={evt => OnTableFilter(evt, viewStore.tableFilter.onTableFilter, column)}
						data-tip={t(column.title)}
						data-cy={`${column.key}-filter`}
					></i>
				) : null}
				<span data-tip={t(column.title)}>
					<label className="label" data-cy={`${column.key}-sort-label`}>
						{t(column.title)}
					</label>
					{column.sortable && (
						<i
							className={
								'cursor--pointer fa fa-angle-' +
								(viewStore &&
									viewStore.queryUtility &&
									column.key === viewStore.queryUtility.filter.orderBy &&
									sortArrow)
							}
							data-cy={`${column.key}-sort`}
						></i>
					)}
				</span>
			</div>
		</section>
	);
};

const ReservedTooltipCellData = ({ dataItem, field, extraField, rowType }) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	if (dataItem[extraField] == null) {
		dataItem[extraField] = 0;
	}
	if (dataItem[field] == null) {
		dataItem[field] = 0;
	}
	return (
		<td colSpan="1">
			<p
				data-tip={translate([
					'PRODUCTDETAILVIEW.INVENTORY.CELL.RESERVEDANDPENDINGPICKUP',
					{ reserved: dataItem[field], pendingPickup: dataItem[extraField] },
				])}
			>
				{dataItem[field] + dataItem[extraField]}
			</p>
		</td>
	);
};

const CommandCellData = ({
	dataItem,
	update,
	cancel,
	edit,
	removeRow,
	editField,
	t,
	rowType,
	onInventoryLogPerWarehouse,
	allowEdit,
	showCustomActions,
}) => {
	if (rowType === 'groupHeader') {
		return null;
	}

	const inEdit = dataItem[editField];
	const inEditWarehouseQuantity = dataItem ? dataItem.whqty : null;

	if (showCustomActions || allowEdit) {
		return (
			<td className="k-command-cell">
				{/* inEdit = true */}
				{allowEdit &&
					inEdit &&
					(!inEditWarehouseQuantity ? (
						<button
							className="btn btn--sml btn--primary spc--right--sml"
							disabled={!isSome(dataItem.productId) || !isSome(dataItem.warehouseId)}
							onClick={() => update(dataItem)}
						>
							{t('ADD')}
						</button>
					) : (
						<button
							className="btn btn--sml btn--primary spc--right--sml"
							disabled={false}
							onClick={() => update(dataItem)}
						>
							{t('UPDATE')}
						</button>
					))}
				{allowEdit &&
					inEdit &&
					(isSome(dataItem.id) ? (
						<button className="btn btn--sml btn--ghost" onClick={() => cancel(dataItem)}>
							{t('CANCEL')}
						</button>
					) : (
						<button className="btn btn--sml btn--ghost" onClick={() => removeRow(dataItem.idx)}>
							{t('REMOVE')}
						</button>
					))}
				{/* inEdit = false */}
				<div className="flex--primary flex--align--right">
					{allowEdit && !inEdit && (
						<i className="fas fa-edit cursor--pointer spc--right--sml" title="Edit" onClick={() => edit(dataItem)}></i>
					)}
					{allowEdit &&
						!inEdit &&
						(dataItem.isNewRow && (
							<i
								className="fas fa-trash-alt cursor--pointer spc--right--sml"
								title="Delete"
								onClick={() => removeRow(dataItem.idx)}
							></i>
						))}

					{/* CUSTOM ACTIONS  */}
					{showCustomActions &&
						!inEdit &&
						!dataItem.isNewRow &&
						(isSome(onInventoryLogPerWarehouse) && (
							<i
								className="fas fa-history cursor--pointer spc--right--sml"
								title="Inventory History"
								onClick={() => onInventoryLogPerWarehouse(dataItem)}
							></i>
						))}
				</div>
			</td>
		);
	}
};

const TooltipHeaderCellData = ({ title, translation, t }) => {
	return (
		<section className="table__head--data">
			<div className="table__head--iconwrap">
				<span data-tip={t(translation)}>
					<label className="label">{title}</label>
				</span>
			</div>
		</section>
	);
};

const OnSelectAllCheckboxHeader = ({ onHeaderChange, isSelectAllCheckboxSelected }) => {
	return (
		<section className="table__head--data">
			<div className="table__head--iconwrap">
				<BaasicCheckbox
					className="input--check input--check--no-label"
					onChange={() => onHeaderChange()}
					checked={isSelectAllCheckboxSelected}
					id={'select--all--checkbox'}
				/>
			</div>
		</section>
	);
};

const OrderChannelHyperLinkCellData = ({ onClick, expandable, t, field, locked, showSelectAllColumn, dataItem }) => {
	let data = _.get(dataItem, field);
	return (
		<td
			colSpan="1"
			className={
				locked
					? expandable
						? 'k-custom-frozen k-custom-frozen--expand'
						: showSelectAllColumn
						? 'k-custom-frozen k-custom-frozen--checkboxexpand'
						: 'k-custom-frozen'
					: null
			}
		>
			{isSome(data) && dataItem.fulfillmentOrder.order.channel.channelType.name != channelType.walmart ? (
				<a
					onClick={() =>
						onClick(dataItem.fulfillmentOrder.order, dataItem.fulfillmentOrder.order.channel.channelType.name)
					}
				>
					{data}
				</a>
			) : (
				<p>{data}</p>
			)}
		</td>
	);
};

const CloseOutsCellData = ({ dataItem, field }) => {
	const selectedProperty = _.get(dataItem, field);

	return (
		<td colSpan="1" className="center">
			{isSome(selectedProperty) && selectedProperty ? (
				<i className="type--color--success fas fa-check-circle" />
			) : (
				<i className="fas fa-times-circle"></i>
			)}
		</td>
	);
};

export {
	CustomActions,
	DateTimeCellData,
	TimeCellData,
	MultipleCellData,
	ProductActivityCellData,
	StatusCellData,
	HyperlinkCellData,
	CarrierDeliveryStatusCellData,
	ZoneCellData,
	CurrencyCellData,
	ChargesCellData,
	ChargesDifferenceCellData,
	HistoryPropertyCellData,
	ImageCellData,
	ButtonCellData,
	BaasicHeaderCellData,
	checkPermissions,
	TooltipHeaderCellData,
	BooleanToggleCellData,
	PalletCellData,
	ProductHyperLinkCellData,
	UsernameCellData,
	DescriptionCellData,
	BooleanCellData,
	BuyerRequestedCancelCellData,
	InventoryDataCell,
	ProductHistoryLogSkuCellData,
	ShippingCostCellData,
	DropdownCellData,
	RateCellData,
	CommandCellData,
	WeightCellData,
	OnTableFilter,
	ContainerProductHyperlinkCellData,
	FulfillmentOrderIdHyperlinkCellData,
	OrderLinesHyperlinkCellData,
	ReservedTooltipCellData,
	OnSelectAllCheckboxHeader,
	DatetimeFromShippingInfoCellData,
	BulkPrintHistoryFOrders,
	CheckboxCellData,
	BulkPrintHistoryNameTooltipCellData,
	OrderChannelHyperLinkCellData,
	PasswordExpirationCellData,
	HyperLinkOrderNumberCellData,
	HyperLinkTrackingNumberCellData,
	CloseOutsCellData,
	TooltipDateTimeCellData,
	IconCellData,
	QuantityPerSkuCellData,
};



// WEBPACK FOOTER //
// ./src/core/stores/CellDataStore.js